import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Loading from "../../../Components/Loading";
import { replaceCommonEncodings } from "../../../modules/string-tools";
import {
  FaChevronRight,
  FaRegPlusSquare,
  FaRegMinusSquare,
} from "react-icons/fa";
import TrapezeHeader from "../../../Components/TrapezeHeader";
import { isOfferVisible } from "../../../utils";
import { formatDate } from "../../../modules/dates";
import { checkVenueForPreferredProgramme } from "../../../services/hotelGroupService/preferredProgrammesService";

const renderItem = (offer, index, array) => {
  const { id, title, valid_from, valid_to } = offer;
  const validFrom = formatDate(valid_from, "DD/MM/YYYY");
  const validTo = formatDate(valid_to, "DD/MM/YYYY");

  return (
    <li
      key={id}
      className={`py-5 px-3 ${index < array.length - 1 &&
        "border-b border-light-blue-grey"}`}
    >
      <Link to={`/offer/${id}`} className="text-black flex">
        <div className="w-4/5">
          <h3 className="mb-0">{replaceCommonEncodings(title)}</h3>
          <p
            title={"Valid between"}
            className="text-dark-red uppercase text-sm font-semibold mb-0"
          >
            {validFrom} - {validTo}
          </p>
        </div>{" "}
        <div className="w-1/5 flex justify-end items-center">
          <FaChevronRight className="text-light-blue-grey text-2xl" />{" "}
        </div>
      </Link>
    </li>
  );
};

const SpecialOffers = ({ loading, offers, mobile, anchor, token }) => {
  const [expanded, setExpanded] = useState(false);
  const [_items, setItems] = useState([]);
  useEffect(() => {
    checkVenueForPreferredProgramme(token).then(response => {
      let filteredItems = offers.filter(item => {
        let agencyProgrammes = [];
        let companyProgrammes = [];
        if (item.apply_to_preferred_programmes_only) {
          let venues = item.venues.map(venue => venue.id);

          if (response && response.agency) {
            agencyProgrammes = response.agency.filter(value =>
              venues.includes(value)
            );
          }
          if (response && response.company) {
            companyProgrammes = response.company.filter(value =>
              venues.includes(value)
            );
          }
          if (agencyProgrammes.length === 0 && companyProgrammes.length === 0) {
            return;
          } else {
            return item.type.name === "special-offers" && isOfferVisible(item);
          }
        } else {
          return item.type.name === "special-offers" && isOfferVisible(item);
        }
      });
      setItems(filteredItems);
    });
  }, []);

  const toggle = () => {
    setExpanded(!expanded);
  };

  if (_items.length === 0) return null;

  return (
    <div className="bg-white mb-3 shadow text-center" id="insights">
      <span className="anchor" id={anchor}>
        Offers section
      </span>
      <div
        className={`flex flex-wrap justify-between items-center bg-white pointer pr-3 lg:cursor-default`}
        onClick={toggle}
      >
        <TrapezeHeader
          title={`Special Offers`}
          textLeft
          bgColor="dark-red"
          bigText
        />
        {expanded ? (
          <FaRegMinusSquare className="pointer lh:hidden" />
        ) : (
          <FaRegPlusSquare className="pointer lg:hidden" />
        )}
      </div>
      {/*<h2*/}
      {/*  className={`mb-2 py-4 ${*/}
      {/*    mobile*/}
      {/*      ? "px-3 text-left w-full flex items-center justify-between"*/}
      {/*      : "text-center"*/}
      {/*  } text-xl ${(expanded || !mobile) &&*/}
      {/*    "border-b border-light-blue-grey"}`}*/}
      {/*  onClick={toggle}*/}
      {/*>*/}
      {/*  Special Offers*/}
      {/*  {mobile && !expanded && <FaRegPlusSquare className="text-base" />}*/}
      {/*  {mobile && expanded && <FaRegMinusSquare className="text-base" />}*/}
      {/*</h2>*/}
      {(!mobile || (mobile && expanded)) &&
        (loading ? (
          <Loading />
        ) : (
          <ul className="list-reset text-left">{_items.map(renderItem)}</ul>
        ))}
    </div>
  );
};

export default SpecialOffers;
